<template>
  <v-card class="elevation-1">
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <img
                id="PreviewImage"
                :src="preview"
                :alt="formModel.FirstName"
              />
              <input type="file" @change="readURL($event)" ref="fileInput" />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="formModel.FirstName"
                :counter="counter.FirstName"
                :rules="getRules.FirstName"
                name="FirstName"
                label="First Name"
                id="FirstName"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="formModel.LastName"
                :counter="counter.LastName"
                :rules="getRules.LastName"
                name="LastName"
                label="Last Name"
                id="LastName"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                v-model="formModel.DlNo"
                :counter="counter.DlNo"
                :rules="getRules.DlNo"
                name="DlNo"
                label="DL No"
                id="DlNo"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md5>
              <v-text-field
                v-model="formModel.Email"
                :counter="counter.Email"
                :rules="getRules.Email"
                name="Email"
                label="Email"
                id="Email"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-select
                v-model="formModel.Batch"
                :items="batches"
                item-text="Name"
                name="Batch"
                label="Batch"
                id="Batch"
                required
                item-value="Id"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="formModel.MothersName"
                :counter="counter.MothersName"
                :rules="getRules.MothersName"
                name="MothersName"
                label="Mother's Name"
                id="MothersName"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="formModel.FathersName"
                :counter="counter.FathersName"
                :rules="getRules.FathersName"
                name="FathersName"
                label="Father's Name"
                id="FathersName"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12>
              <v-textarea
                v-model="formModel.Address"
                :counter="counter.Address"
                :rules="getRules.Address"
                name="Address"
                label="Address"
                id="Address"
                required
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-menu
                v-model="dobPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formModel.DateOfBirth"
                    name="DateOfBirth"
                    id="DateOfBirth"
                    label="Date Of Birth"
                    hint="YYYY-MM-DD format"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formModel.DateOfBirth"
                  @input="dobPicker = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="formModel.Phone"
                :counter="counter.Phone"
                :rules="getRules.Phone"
                name="Phone"
                label="Phone"
                id="Phone"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="formModel.Year"
                :counter="counter.Year"
                :rules="getRules.Year"
                name="Year"
                label="Year"
                id="Year"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="formModel.Month"
                :counter="counter.Month"
                :rules="getRules.Month"
                name="Month"
                label="Month"
                id="Month"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="formModel.Age"
                :counter="counter.Age"
                :rules="getRules.Age"
                name="Age"
                label="Age"
                id="Age"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Gender"
                :items="dropdowns.gender"
                name="Gender"
                label="Gender"
                id="Gender"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Location"
                :items="dropdowns.location"
                name="Location"
                label="Location"
                id="Location"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.MaritalStatus"
                :items="dropdowns.marital_status"
                name="MaritalStatus"
                label="Marital Status"
                id="MaritalStatus"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Religion"
                :items="dropdowns.religion"
                name="Religion"
                label="Religion"
                id="Religion"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.IdType"
                :items="dropdowns.id_type"
                name="IdType"
                label="ID Type"
                id="IdType"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="formModel.IdNo"
                :counter="counter.IdNo"
                :rules="getRules.IdNo"
                name="IdNo"
                label="ID Number"
                id="IdNo"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-text-field
                v-model="formModel.Pin"
                :counter="counter.Pin"
                name="Pin"
                label="Pin"
                id="Pin"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Occupation"
                :items="dropdowns.occupation"
                name="Occupation"
                label="Occupation"
                id="Occupation"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Qualification"
                :items="dropdowns.qualification"
                name="Qualification"
                label="Qualification"
                id="Qualification"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Category"
                :items="dropdowns.category"
                name="Category"
                label="Category"
                id="Category"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-menu
                v-model="dateOfEnrolmentPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formModel.DateOfEnrolment"
                    name="DateOfEnrolment"
                    id="DateOfEnrolment"
                    label="Date Of Enrolment"
                    hint="YYYY-MM-DD format"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formModel.DateOfEnrolment"
                  @input="dateOfEnrolmentPicker = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.Background"
                :items="dropdowns.background"
                label="Background"
                name="Background"
                id="Background"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <v-select
                v-model="formModel.AnnualIncome"
                :items="dropdowns.annual_income"
                label="Annual Income"
                name="AnnualIncome"
                id="AnnualIncome"
                required
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-checkbox
                v-model="formModel.HaveDisability"
                name="HaveDisability"
                label="I Have Disability"
                id="HaveDisability"
                required
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-checkbox
                v-model="formModel.IdConfirmedByPartner"
                name="IdConfirmedByPartner"
                label="ID Confirmed By Partner"
                id="IdConfirmedByPartner"
                required
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" outline @click="cancel">Cancel</v-btn>
      <v-btn color="primary" @click="save" :disabled="!valid">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import firebase from "../firebase/firebase";
import dbStore from "../db/dbStore";
import StudentStore from "../db/studentStore";
import Rules from "../rules";
import Utils from "../utils";

export default {
  name: "StudentForm",
  data: function() {
    return {
      valid: true,
      dobPicker: false,
      preview: "",
      previousProfileImage: "",
      isProfileImageChanged: false,
      isPreviousProfileImageUploaded: false,
      dateOfEnrolmentPicker: false,
      storageRef: "images/profiles/",
      newImageId: "",
      models: {},
      formModel: {},
      counter: {
        DlNo: 20,
        FirstName: 20,
        LastName: 20,
        Email: 100,
        MothersName: 20,
        FathersName: 20,
        Address: 500,
        Phone: 15,
        Year: 10,
        Month: 10,
        Age: 3,
        Pin: 10
      },
      studentFields: [
        "FirstName",
        "LastName",
        "Email",
        "DateOfEnrolment",
        "Batch"
      ],
      studentProfileFields: [
        "DlNo",
        "ProfileImage",
        "FirstName",
        "LastName",
        "Email",
        "DateOfBirth",
        "Phone",
        "Address",
        "Year",
        "Month",
        "Age",
        "Gender",
        "Location",
        "MothersName",
        "FathersName",
        "IdType",
        "IdNo",
        "MaritalStatus",
        "Religion",
        "Occupation",
        "Qualification",
        "Category",
        "IdConfirmedByPartner",
        "Pin",
        "Background",
        "AnnualIncome",
        "HaveDisability"
      ],
      dropdownColumnMappings: {
        Gender: "gender",
        Location: "location",
        IdType: "id_type",
        MaritalStatus: "marital_status",
        Religion: "religion",
        Occupation: "occupation",
        Qualification: "qualification",
        Category: "category",
        Background: "background",
        AnnualIncome: "annual_income"
      },
      checkBoxColumns: ["HaveDisability", "IdConfirmedByPartner"],
      batchModel: {
        Id: "",
        Name: "",
        Center: "",
        StartDate: "",
        EndDate: "",
        NoOfStudents: "",
        Students: ""
      }
    };
  },
  props: {
    formContext: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    dropdowns: {
      type: Object,
      required: false
    },
    batches: {
      type: Array,
      required: false
    },
    isStudentFormEnabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    getRules() {
      var rulesObject = Rules.getComponentRules("Student");
      //console.log(rulesObject)
      return rulesObject;
    },
    formTitle() {
      var title = "";
      if (this.formContext == "add") {
        title = "Add Student";
      } else if (this.formContext == "edit") {
        title = "Edit Student";
      }
      return title;
    }
  },

  watch: {
    isStudentFormEnabled() {
      //console.log("entered")
      //on add student case, in edit we dont need, this is useful to track
      //back button on top right and reset form if user clicks back and comes
      //here again, then form is reset
      if (this.isStudentFormEnabled) {
        this.formModel = Object.assign({}, this.models[this.formContext]);
        this.$refs.form.resetValidation();
      }
    }
  },

  created() {
    //when created
    // in add store empty model so that when we come back we can reset it
    // in edit store model data into editedModel so when we make changes and
    // come back then all changes will be lost and original model data is visible
    this.models[this.formContext] = Object.assign({}, this.model);
  },
  async mounted() {
    //when we click add student in students page and come back then show empty model
    // as if we are adding new student
    // in edit mode when we come back for second time then reset changes
    // and show original model. So saving those stuff into formModel here
    this.formModel = Object.assign({}, this.models[this.formContext]);
    this.getPreview();
  },
  methods: {
    setupStudentModels(context) {
      var studentModel = {},
        studentProfileModel = {},
        //#TODO check if batchModel is really needed in data section
        batchModel = {},
        editedBatchModel = {};
      this.studentFields.forEach(element => {
        studentModel[element] = this.formModel[element];
      });
      studentModel["Status"] = "Draft";

      this.studentProfileFields.forEach(element => {
        studentProfileModel[element] = this.formModel[element];
      });

      this.checkBoxColumns.forEach(element => {
        if (studentProfileModel[element] == "")
          studentProfileModel[element] = false;
      });

      if (context == "edit") {
        Object.assign(
          batchModel,
          Utils.getItemFromListWithId(this.batches, this.model.Batch)
        );
        Object.assign(
          editedBatchModel,
          Utils.getItemFromListWithId(this.batches, studentModel.Batch)
        );
      } else if (context == "add") {
        Object.assign(
          batchModel,
          Utils.getItemFromListWithId(this.batches, studentModel.Batch)
        );
      }

      var keys = Object.keys(this.dropdownColumnMappings);
      keys.forEach(element => {
        var valueArray = this.dropdowns[this.dropdownColumnMappings[element]];
        var selectedValue = studentProfileModel[element];
        var index = valueArray.indexOf(selectedValue);
        //console.log("selectedValue -> "+ selectedValue + " Index->"+index)
        studentProfileModel[element] = index;
      });
      return {
        model: this.model,
        studentModel: studentModel,
        studentProfileModel: studentProfileModel,
        batchModel: batchModel,
        editedBatchModel: editedBatchModel
      };
    },

    async addStudent() {
      let response;
      try {
        var models = this.setupStudentModels("add");
        //console.log(models)
        console.log(this.newImageId);
        if (this.newImageId === "") {
          //newImageId is "" when the image upload hasn't happened
          this.newImageId = dbStore.getNewId();
          //Give empty path
          models.studentProfileModel.ProfileImage = "";
        }
        response = await StudentStore.addStudentToBatch(
          models,
          this.newImageId
        );
        if (response.isCommitted) {
          this.$refs.form.resetValidation();
          this.$emit("studentFormAddEvent", true);
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error adding student : " + err);
      }
    },

    async updateStudent() {
      let response;
      try {
        var models = this.setupStudentModels("edit");
        //console.log(models)

        response = await StudentStore.updateStudentToBatch(
          this.model.Id,
          models
        );
        if (response.isCommitted) {
          this.$refs.form.resetValidation();
          this.$emit("studentFormUpdateEvent", true);
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error adding student : " + err);
      }
    },

    fileReset() {
      const input = this.$refs.fileInput;
      input.type = "text";
      input.type = "file";
    },

    cancel() {
      this.$refs.form.resetValidation();
      var status = this.manageProfileImage();
      if (status) {
        this.fileReset();
        this.$emit("studentFormCancelEvent", true);
      }
    },

    save() {
      if (this.$refs.form.validate()) {
        if (this.formContext == "add") {
          //console.log(this.formModel);
          this.addStudent();
        } else if (this.formContext == "edit") {
          //console.log(this.formModel);
          this.updateStudent();
        }
      }
    },

    async manageProfileImage() {
      var status = false;
      if (this.isProfileImageChanged) {
        if (this.formContext == "add") {
          //remove the uploaded file
          await this.removeFile(this.model.Id);
          status = true;
        } else if (this.formContext == "edit") {
          //remove uploaded file
          await this.removeFile(this.model.Id);
          //upload the old file because we are cancelling edit operation
          await this.uploadPreviousFile(this.model.Id);
          console.log("done with uploading file");
          status = true;
          this.getPreview();
        }
      }
      return status;
    },

    async readURL(e) {
      try {
        var Id = "";
        var files = e.target.files || e.dataTransfer.files;
        if (files && files[0]) {
          let data = await this.readFileAsync(files[0]);

          this.preview = data;
          this.isProfileImageChanged = true;

          if (this.formContext == "add") {
            //since its new we need to get Id for new image
            Id = dbStore.getNewId();
          } else if (this.formContext == "edit") {
            //get the already existing file so that in case if its cancelled we need to revert back
            this.downloadPreviousProfileImage();
            Id = this.model.Id;
          }

          var profileImageRef = this.getProfileImageReference(Id);
          var snapshot = await profileImageRef.putString(
            this.preview,
            "data_url"
          );
          if (snapshot.state == "success") {
            this.newImageId = Id;
            this.formModel.ProfileImage = this.getProfileImagePath(Id);
          }
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    //#TODO move this to appropriate file
    async fetchAsync(url) {
      //var blob;
      var response = await fetch(url, { mode: "no-cors" });
      //blob = await response.blob();
      return response;
    },

    //#TODO move this to appropriate file
    getProfileImageUrl(path) {
      try {
        var storageReference = firebase.storage().ref();
        var profileImageRef = storageReference.child(path);
        var url = profileImageRef.getDownloadURL();
        return url;
      } catch (err) {
        throw new Error(err);
      }
    },

    //#TODO move this to appropriate file
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },

    //#TODO move this to appropriate file
    async uploadFile() {
      try {
        var Id = dbStore.getNewId();
        var profileImageRef = this.getProfileImageReference(Id);
        var snapshot = await profileImageRef.putString(
          this.preview,
          "data_url"
        );
        if (snapshot.state == "success") {
          this.newImageId = Id;
          this.formModel.ProfileImage = this.getProfileImagePath(Id);
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    //#TODO move this to appropriate file
    async uploadPreviousFile(Id) {
      try {
        var profileImageRef = this.getProfileImageReference(Id);
        var snapshot = await profileImageRef.putString(
          this.previousProfileImage,
          "data_url"
        );
        if (snapshot.state == "success") {
          return true;
        }
      } catch (err) {
        throw new Error(err);
      }
    },

    //#TODO move this to appropriate file
    async removeFile(Id) {
      try {
        var profileImageRef = this.getProfileImageReference(Id);
        await profileImageRef.delete();
      } catch (err) {
        throw new Error(err);
      }
    },

    //#TODO move this to appropriate file
    getProfileImageReference(Id) {
      try {
        var storageReference = firebase.storage().ref();
        var profileImageRef = storageReference.child(
          this.getProfileImagePath(Id)
        );
        return profileImageRef;
      } catch (err) {
        throw new Error(err);
      }
    },

    //#TODO move this to appropriate file
    getProfileImagePath(Id) {
      return this.storageRef + Id + ".jpg";
    },

    async getPreview() {
      if (this.formContext == "edit") {
        if (this.model.ProfileImage !== "")
          this.preview = await this.getProfileImageUrl(this.model.ProfileImage);
      }
    },

    //#TODO move this to appropriate file
    downloadUrlAsyncXHR(url) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.responseType = "blob";

        xhr.onload = () => {
          resolve(xhr.response);
        };
        xhr.open("GET", url);
        xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
        xhr.send();

        xhr.onerror = reject;
      });
    },

    //#TODO move this to appropriate file
    async downloadPreviousProfileImage() {
      if (this.formModel.ProfileImage !== "") {
        var url = await this.getProfileImageUrl(this.formModel.ProfileImage);
        var blob = await this.downloadUrlAsyncXHR(url);
        this.previousProfileImage = await this.readFileAsync(blob);
      } else {
        this.previousProfileImage = "";
      }
    }
  }
};
</script>
<style scoped>
img {
  max-width: 124px;
}
input[type="file"] {
  padding: 10px;
  background: #fff;
}
</style>
